(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-template"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var successData = document.getElementById('contact-success-data');
  if (successData) {
    var popup = document.getElementById('contactPopup');
    var content = document.getElementById('popup-content');
    // Copy the success message into the popup
    content.innerHTML = successData.innerHTML;

    popup.style.display = 'flex';

    var closeBtn = popup.querySelector('.close-popup');
    closeBtn.addEventListener('click', function() {
      popup.style.display = 'none';
    });

    popup.addEventListener('click', function(e) {
      if (e.target === popup) {
        popup.style.display = 'none';
      }
    });

    // Auto-close after 5 seconds
    setTimeout(function() {
      popup.style.display = 'none';
    }, 5000);
  }
});

  } catch(e) { console.error(e); }
})();
})();
